
//TODO:
import React from 'react';
import {bool, string, func, object, shape, element, array, arrayOf, number} from 'prop-types';
import {isEmpty} from 'lodash';

import {Message, Panel} from '@sabre/spark-react-core';
import {Toolbar, ToolbarItem} from '@sabre/spark-react';
import {SIZE} from '../../utils/constants.js';
import {CHART_TYPE} from '../chart-wrapper/chart-constants.js';

import Loader from '../loader/loader.jsx';
import ToggleTabs from '../toggle-tabs/toggle-tabs.jsx';
import BarChartWrapper from '../chart-wrapper/bar-chart-wrapper/bar-chart-wrapper.jsx';
import LineChartWrapper from '../chart-wrapper/line-chart-wrapper/line-chart-wrapper.jsx';
import BarChartStackedGroupedWrapper from '../chart-wrapper/bar-chart-stacked-grouped-wrapper/bar-chart-stacked-grouped-wrapper.jsx';


const ChartPanel = ({
    chartType,
    cssClasses = {},
    isLoading,
    chartData,
    configChart,
    apiErrorMessage,
    toolbarConfig
}) => {

    const {
        isShowToolbar = false,
        refreshIconOnClickHandler = () => {},
        gridChartIconOnClickHandler = () => {}
    } = toolbarConfig || {};

    const isShowError = () => !isLoading && !isEmpty(apiErrorMessage);
    const isShowChartFilters = () => !isLoading && isEmpty(apiErrorMessage) && !isEmpty(chartData) && !isEmpty(configChart.chartFilters);
    const isShowToggle = () => !isLoading && isEmpty(apiErrorMessage) && !isEmpty(configChart.configToggle);
    const isShowChartData = () => !isLoading && isEmpty(apiErrorMessage);

    const commonCssClassPostfix = chartTitle => chartTitle.replace(/\s+/ig, '-').toLowerCase();

    return (
        <Panel className={`chart-panel${cssClasses.panelCss ? ` chart-panel-${cssClasses.panelCss}` : ` chart-panel-${commonCssClassPostfix(configChart.chartTitle)}`}`}>
            <div className={`row chart-panel-header${cssClasses.panelHeaderCss ? ` chart-panel-header-${cssClasses.panelHeaderCss}` : ` chart-panel-header-${commonCssClassPostfix(configChart.chartTitle)}`}`}>
                <div className='col-xs-6'>
                    <div><h5>{configChart.chartTitle}</h5></div>
                    {configChart.chartDescription ? <div className={`chart-description`}>{configChart.chartDescription}</div> : null}
                </div>
                <div className='col-xs-6'>
                    <div className='row'>
                        <div className='col-xs-12'>{isShowChartFilters() && <div className='chart-filters-container spark-mar-t-1'>{configChart.chartFilters}</div>}</div>
                        <div className='col-xs-12'>
                            {!isEmpty(toolbarConfig) && <Toolbar className='spark-toolbar--icon'>
                                <ToolbarItem
                                    label={`${configChart.chartTitle} Table Grid`}
                                    iconClass='spark-icon-view-grid-3x3'
                                    onClick={isShowToolbar && !isEmpty(chartData) && !isEmpty(configChart.configBars.plotBars) ? () => gridChartIconOnClickHandler(configChart.chartTitle) : () => {
                                    }}
                                />
                            </Toolbar>}
                        </div>
                    </div>
                </div>
            </div>

            <div className='row'>
                <div className='col-xs-12'>
                    {
                        isShowToggle() &&
                        !isEmpty(chartData) &&
                        ((configChart.configBars && !isEmpty(configChart.configBars.plotBars)) || (configChart.configLines && !isEmpty(configChart.configLines.plotLines))) &&
                        <ToggleTabs configToggle={configChart.configToggle} />
                    }
                </div>

                <div className='col-xs-12'>
                    {isLoading && <Loader size={SIZE.SMALL} />}
                    {isShowError() && <Message data-testid='chart-error' title={apiErrorMessage.title} content={apiErrorMessage.content} status={apiErrorMessage.type} type='container' role='alert' />}
                    {chartType === CHART_TYPE.BAR_CHART && isShowChartData() && <BarChartWrapper chartData={chartData} configChart={configChart} />}
                    {chartType === CHART_TYPE.BAR_CHART_STACKED_GROUPED && isShowChartData() && <BarChartStackedGroupedWrapper chartData={chartData} configChart={configChart} />}
                    {chartType === CHART_TYPE.LINE_CHART && <LineChartWrapper chartData={chartData} configChart={configChart} />}
                </div>

                {configChart.chartDenotation ? <div className='row chart-denotation'>{configChart.chartDenotation}</div> : null}
            </div>
        </Panel>
    );
};

ChartPanel.propTypes = {
    chartType: string.isRequired,
    cssClasses: shape({
        panelCss: string,
        panelHeaderCss: string
    }),
    isLoading: bool,
    chartData: array.isRequired,
    configChart: shape({
        chartWidth: number,
        chartHeight: number,
        chartTitle: string.isRequired,
        configBars: shape({
            plotBars: arrayOf(string).isRequired,
            isHighLightBarOnClick: bool,
            isHighLightCellOnClick: bool,
            isStackedBars: bool,
            barSize: number,
            barStrokes: object,
            isBarRoundedEdge: bool,
            isSetBarBackground: bool,
            barBackgroundColor: string,
            barOnClickHandler: func
        }).isRequired,
        configXAxis: shape({
            xAxisKey: string.isRequired,
            xAxisTickFormatter: func
        }).isRequired,
        configYAxis: shape({
            yAxisTickFormatter: func
        }),
        chartFilters: element,
        configToggle: shape({
            toggleName: string.isRequired,
            className: string,
            toggle: arrayOf(
                shape({
                    toggleLabel: string.isRequired,
                    toggleValue: string.isRequired,
                    className: string
                })).isRequired
        }.isRequired),
        configLegends: shape({
            legendLabels: object,
            isToggleChartOnClickOfLegend: bool,
            legendIcon: string,
            isLegendTextColorSameAsChartColor: bool
        }),
        isVisibleHorizontalGrid: bool,
        tooltipContent: element
    }),
    apiErrorMessage: object,
    toolbarConfig: shape({
        isShowToolbar: bool,
        refreshIconOnClickHandler: func,
        gridChartIconOnClickHandler: func
    }),
    toggleTabOnClickHandler: func,
    toggleCheckedValue: string
};

export default ChartPanel;
